module.exports = "/assets/data/33adc2bbb77973876f95a69cb8bac6c3-NE12.data.json";